import { DatePipe } from '@angular/common';
import { Component, inject, viewChild } from '@angular/core';
import { IgxOverlayService } from '@infragistics/igniteui-angular/core';
import {
  IGX_DIALOG_DIRECTIVES,
  IgxDialogComponent,
} from '@infragistics/igniteui-angular/dialog';
import { IGX_LIST_DIRECTIVES } from '@infragistics/igniteui-angular/list';
import { Subject } from 'rxjs';

import { ErrorDialogData } from '@VineyardLib/data/error-dialog-data';
import { messageData } from '@VineyardLib/data/message-data';
import { LabelTranslatePipe } from '@VineyardLib/pipes/labelTranslate.pipe';
import { MessageTranslatePipe } from '@VineyardLib/pipes/messageTranslate.pipe';
import { ERROR_DIALOG_SERVICE_TOKEN } from '@VineyardLib/services/error-dialog-wrapper.service';
import { overlayStyleClasses } from '@VineyardLibConstant/constant';

/**
 * エラーダイアログ
 */
@Component({
  selector: 'app-pc-tablet-error-dialog-component',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: [
    // Angular標準
    DatePipe,
    // IgniteUI
    IGX_DIALOG_DIRECTIVES,
    IGX_LIST_DIRECTIVES,
    // 内部パイプ
    LabelTranslatePipe,
    MessageTranslatePipe,
  ],
})
export class PcTabletErrorDialogComponent {
  private overlayService = inject<IgxOverlayService>(IgxOverlayService);
  private dialogService = inject(ERROR_DIALOG_SERVICE_TOKEN);

  private readonly errorDialog = viewChild<IgxDialogComponent>('errorDialog');

  data?: ErrorDialogData;
  messageList: messageData[] = [];
  dialogClosed = new Subject<boolean>();

  ngAfterViewInit(): void {
    // 上記サービスに、エラー表示用のダイアログコンポーネントインスタンスへの参照を代入
    if (this.errorDialog !== undefined) {
      this.dialogService.errorDialog = this;
    }
  }

  openDialog(data: ErrorDialogData): void {
    const errorDialog = this.errorDialog();
    if (errorDialog == null) {
      return;
    }

    this.data = data;
    this.messageList = this.messageList.concat(this.data.message); // messageDataとmessageData[]のどちらが来ても動作するように配列に変換する
    errorDialog.open();

    // overlayの重なり順の制御のため、z-index制御のためのスタイルクラスをoverlayに追加する
    this.overlayService
      .getOverlayById(errorDialog.toggleRef.overlayId)
      .wrapperElement?.classList.add(overlayStyleClasses.messageDialog);
  }

  onClosed(): void {
    this.dialogClosed.next(true);
    this.messageList = [];
  }
}
